import { compose } from 'redux';
import { connect } from 'react-redux';
import DazePracticeView from './DazePracticeView';
import selectors from '../../../rootSelectors';
import { fetchDazeContent, clearResponses } from '../../dazeActions';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import { DAZE_INSTRUCTIONS } from '../../dazeConstants';
import { stopAudio } from '../../../common/audio/audioActions';
import { unmountScreen, blockScreen, greyOutScreen } from '../../../common/screen/screenActions';
import { playPracticeScript, selectPracticeScreenResponse } from './DazePracticeActions';
import { PRACTICE } from '../../../constants/assessmentItemType';
import { goToModelScroll } from '../../../common/navigation/navigationActions';
import { DAZE } from '../../../constants/measure';

const mapStateToProps = (state) => ({
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isScreenGreyedOut: selectors.getIsScreenGreyedOut(state),
    isNextButtonActive: selectors.getIsNextButtonActive(state),
    isDataFetched: selectors.getIsDazeDataFetched(state),
    paragraphs: selectors.getDazeParagraphs(state, PRACTICE),
    questions: selectors.getDazeQuestionItems(state, PRACTICE),
    selectedResponses: selectors.getDazeSelectedResponses(state),
});

const mapDispatchToProps = (dispatch) => ({
    readPracticeScript: () => {
        dispatch(blockScreen());
        dispatch(greyOutScreen());
        dispatch(playPracticeScript());
    },
    fetchContent: () => {
        dispatch(fetchDazeContent());
    },
    onResponseSelected: (questionId, responseId) => {
        dispatch(selectPracticeScreenResponse(questionId, responseId));
    },
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(clearResponses());
        dispatch(unmountScreen());
    },
    onNext: () => {
        dispatch(goToModelScroll(DAZE));
    },
});

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.MIDDLE_LEFT,
    instructions: DAZE_INSTRUCTIONS.passageInstruction,
});

const DazePracticeContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(DazePracticeView);

export default DazePracticeContainer;
